import ErrorDisplay from './error-display.jsx';
import { connect } from 'react-redux';
import { clearError } from '../../app-dux/app-dux';
import { getPrimaryExperienceUrl } from '../../app-dux/interaction-dux';

export default connect(
    // mapStateToProps
    state => ( {
        errors: state.app.error
    } ),
    // mapDispatchToProps
    {
        clearError,
        getPrimaryExperienceUrl
    }
)( ErrorDisplay );
